import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const getVisibiltyOptions = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/visibility-options`,
      headers: {
         Accept: "*/*"
      }
   });
};

export const changeVisibilityOptions = async (newOptions) => {
   return axios({
      method: "put",
      url: `${hostCloud}/visibility-options`,
      headers: {
         Accept: "*/*"
      },
      data: newOptions
   });
};
